import uniq from 'lodash/uniq'
import type {StudentAttrs} from '@freckle/educator-entities/ts/users/models/student'

export const getAccessibleGrades = (students: Array<StudentAttrs>): Array<number> =>
  uniq(students.map(student => student.grade)).sort((a, b) => a - b)
